var FreeGift = class extends HTMLElement {
  static _settling = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.settings = JSON.parse(document.querySelector(`[data-gift-settings]`).innerHTML);
    this.enforceOneGift();
    this._onCart = () => this.enforceOneGift();
    document.documentElement.addEventListener('cart:updated', this._onCart);
  }

  disconnectedCallback() {
    if (this._onCart) {
      document.documentElement.removeEventListener('cart:updated', this._onCart);
    }
  }

  /**
   * Remove the gift this cart has stopped earning.
   *
   * The offer is two spend bands and ONE gift that changes between them: the
   * book light from 200, the Xmas lights INSTEAD from 240. The published FAQ
   * is the authority -- "Customers who qualify for more than one gift with
   * purchase offer will receive the higher-value gift only."
   *
   * What gets added is decided by the thresholds multi-tier-gwp.liquid publishes.
   * The case that cannot fix is a gift already sitting in the cart as a line,
   * from an earlier band or a trip to checkout and back. It outlives its
   * attribute and is billed in full, so Liquid lists the lines this cart has not
   * earned, by key, and this removes them.
   *
   * It decides nothing itself, and _mayCorrect limits how often it can act.
   */
  enforceOneGift() {
    const node = document.querySelector(`[data-gift-settings]`);
    if (!node) return;
    let s;
    try {
      s = JSON.parse(node.innerHTML);
    } catch (e) {
      return;
    }

    // Gift lines the cart has not earned, decided in Liquid from cart.items.
    const stale = s.staleKeys || [];
    // Gated: a real bundle is on the cart and the offer is withdrawn. custom.js
    // clears the attributes on its next update, but the update that completed
    // the bundle may have read the previous block, so clear them here too.
    const clearAttrs = Boolean(s.gated && (s.attrOne || s.attrTwo));
    if (!stale.length && !clearAttrs) return;
    if (FreeGift._settling || !this._mayCorrect()) return;

    const body = {};
    if (clearAttrs) body.attributes = { _gwp1: '', _gwp2: '' };
    if (stale.length) {
      body.updates = {};
      stale.forEach((key) => { body.updates[key] = 0; });
    }
    FreeGift._settling = true;
    this._updateCart(body)
      .catch(() => {})
      .then(() => { FreeGift._settling = false; });
  }

  // A circuit breaker. Each correction re-renders the drawer, and this script
  // runs again on render, so anything that keeps undoing a correction would
  // otherwise refresh the cart forever, which is what happened on 4 Nov. Four
  // corrections a minute, across page loads, then it stops and leaves the cart
  // usable. Works without storage, where the in-memory count still applies.
  _mayCorrect() {
    const KEY = 'bbl_gwp_corrections';
    const now = Date.now();
    let log = FreeGift._corrections || [];
    try {
      log = JSON.parse(sessionStorage.getItem(KEY) || '[]');
    } catch (e) {}
    log = log.filter((t) => now - t < 60000);
    if (log.length >= 4) {
      console.warn('GWP: stopped correcting the cart after 4 attempts in a minute.');
      return false;
    }
    log.push(now);
    FreeGift._corrections = log;
    try {
      sessionStorage.setItem(KEY, JSON.stringify(log));
    } catch (e) {}
    return true;
  }

  testThreshold(cart, event){
    /* disabled for now
    console.log(cart)
    console.log('test:'+this.settings.giftInCart+' / '+this.cartTotal+' / '+this.settings.threshold)
    if(event) {
      this.cartTotal = parseFloat(cart.detail["cart"]["total_price"]);
    } else {
      if(cart){
        this.cartTotal = cart.total_price;
      } else {
        this.cartTotal = this.settings.cartTotal;
      }
    }
    console.log(this.cartTotal)
    if(this.settings.giftInCart && this.cartTotal < this.settings.threshold) {
      let formData = {
        updates: {
          [this.settings.giftId]: 0,
          [this.settings.giftTwoId]: 0,
        }
      };
      this._updateCart(formData)
    }
    if(this.cartTotal >= this.settings.threshold && this.cartTotal < this.settings.thresholdTwo) {
      let formData = {
        updates: {
          [this.settings.giftId]: 1,
          [this.settings.giftTwoId]: 0,
        }
      };
      this._updateCart(formData)
    }
    if(!this.settings.giftTwoInCart && this.cartTotal >= this.settings.thresholdTwo) {
      let formData = {
        updates: {
          [this.settings.giftId]: 1,
          [this.settings.giftTwoId]: 1,
        }
      };
      this._updateCart(formData)
    }
    */
  }

  async _updateCart(formData) {
    return new Promise((resolve, reject) => {
      fetch(`/cart/update.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.json())
      .then((response) => {
        const updatedCart = response;
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: updatedCart
          }
        }));
        resolve(updatedCart);
        this.updateGWP();
      })
      .catch((e) => {
          console.error(e);
          reject(e);
      })
    });
  }


  async updateGWP() {
    const res = await fetch(`${window.themeVariables.routes.rootUrl}?section=shopify-section-mini-cart`)
    const section = await res.text();
    const cart = document.createElement('div');
    cart.innerHTML = section;
    const updatedCart = cart.querySelector(`cart-drawer .drawer__content`);
    const currentCart = document.querySelector(`cart-drawer .drawer__content`);
    if (currentCart && updatedCart) {
      currentCart.innerHTML = updatedCart.innerHTML;
    }
  }
};
window.customElements.define('gift-with-purchase', FreeGift);

document.addEventListener("cart:updated", (event) => {
  //document.querySelector('gift-with-purchase').testThreshold(event, true)
});

document.addEventListener("DOMContentLoaded", (event) => {
  //document.querySelector('gift-with-purchase').testThreshold(false, false)
});